const ingredientCardsArray = document.querySelectorAll(".blog-index-section .ingredient-card");
const resetFilterBtnsArray = document.querySelectorAll(".resetFiltersBtn");
const filtersArray = document.querySelectorAll(".filter-term-group");
const mobileFiltersMenu = document.querySelector("#mobileFiltersMenu");
const btnOpenMobileFiltersMenu = document.querySelector("#btnOpenMobileFiltersMenu");
const btnCloseMobileFiltersMenu = document.querySelector("#btnCloseMobileFiltersMenu");

function openMobileMenu() {
  document.querySelector("html").classList.add("u-no-scroll");
  mobileFiltersMenu.classList.remove("u-d-none");
}

function closeMobileMenu() {
  document.querySelector("html").classList.remove("u-no-scroll");
  mobileFiltersMenu.classList.add("u-d-none");
}

function removeActiveFilterStyles() {
  for (const filter of filtersArray) {
    filter.classList.remove("active");
  }
}

btnOpenMobileFiltersMenu.addEventListener("click", openMobileMenu);
btnCloseMobileFiltersMenu.addEventListener("click", closeMobileMenu);

// RESET ALL FILTERS / Show All
for (const resetFilterBtn of resetFilterBtnsArray) {
  resetFilterBtn.addEventListener("click", () => {
    removeActiveFilterStyles();
    // Show all cards
    for (const card of ingredientCardsArray) {
      card.classList.remove("u-d-none");
    }
    closeMobileMenu();
  });
}

// CLICK ON A FILTER
for (const filter of filtersArray) {
  filter.addEventListener("click", (e) => {
    removeActiveFilterStyles();
    e.currentTarget.classList.add("active");
    // hide/show cards
    let filtertag = e.currentTarget.dataset.filtertag;
    for (const card of ingredientCardsArray) {
      if (card.classList.contains(`filter-${filtertag}`)) {
        card.classList.remove("u-d-none");
      } else {
        card.classList.add("u-d-none");
      }
    }
    closeMobileMenu();
  });
}
